import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { OccCartNormalizer } from '@spartacus/cart/base/occ'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { I18nModule, provideConfig, provideConfigFactory, UrlModule } from '@spartacus/core'
import {
  CmsPageGuard,
  DIALOG_TYPE,
  GlobalMessageComponentModule,
  IconModule,
  ItemCounterModule,
  KeyboardFocusModule,
  LayoutConfig,
  MediaModule,
  OutletModule,
  PageLayoutComponent
} from '@spartacus/storefront'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { EbInfoBoxModule } from '../../components/info-box/eb-info-box.module'
import { EbLoadMoreButtonModule } from '../../components/load-more-button/eb-load-more-button.module'
import { EbSpinnerModule } from '../../components/spinner/eb-spinner.module'
import { EbAuthGuard } from '../auth/guards/eb-auth.guard'
import { EbCartModule } from '../cart/eb-cart.module'
import { EbActiveCartService } from '../cart/services/eb-active-cart.service'
import { EbMultiCartService } from '../cart/services/eb-multi-cart.service'
import { EbFormModule } from '../form/eb-form.module'
import { EbProductAvailabilityModule } from '../product/components/product-availability/eb-product-availability.module'
import { EbUserAccountService } from '../user/services/eb-user-account.service'
import { EbAddedFavoritesToCartComponent } from './components/added-favorites-to-cart/eb-added-favorites-to-cart.component'
import { EbFavoritesComponent } from './components/favorites/eb-favorites.component'
import { EbFavoritesCreateDialogComponent } from './components/favorites-create-dialog/eb-favorites-create-dialog.component'
import { EbFavoritesItemComponent } from './components/favorites-item/eb-favorites-item.component'
import { EbFavoritesItemHeaderComponent } from './components/favorites-item-header/eb-favorites-item-header.component'
import { EbFavoritesItemListComponent } from './components/favorites-item-list/eb-favorites-item-list.component'
import { EbFavoritesListComponent } from './components/favorites-list/eb-favorites-list.component'
import {
  ebFavoritesCmsConfigFactory,
  ebFavoritesConfigFactory,
  ebFavoritesRoutingConfigFactory
} from './eb-favorites.config'
import { EbFavoritesAdapter } from './services/connectors/eb-favorites.adapter'
import { EB_FAVORITES_NORMALIZER } from './services/converters/converters'
import { EbFavoritesNormalizer } from './services/converters/eb-favorites.normalizer'
import { EbFavoritesService } from './services/facades/eb-favorites.service'

export const defaultFavoritesDialogModalLayoutConfig: LayoutConfig = {
  launch: {
    ADDED_TO_CART_FAVORITE: {
      inline: true, // OR inlineRoot: true
      component: EbAddedFavoritesToCartComponent,
      dialogType: DIALOG_TYPE.DIALOG
    },
    CREATE_FAVORITE_LIST: {
      inline: true, // OR inlineRoot: true
      component: EbFavoritesCreateDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
}

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    EbSpinnerModule,
    EbCartModule,
    RouterModule.forChild([
      {
        path: null,
        canActivate: [EbAuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'favorites' }
      }
    ]),
    GlobalMessageComponentModule,
    EbFormModule,
    FormsModule,
    EbInfoBoxModule,
    ItemCounterModule,
    EbProductAvailabilityModule,
    MediaModule,
    OutletModule,
    UrlModule,
    EbLoadMoreButtonModule,
    KeyboardFocusModule
  ],
  declarations: [
    EbFavoritesComponent,
    EbFavoritesListComponent,
    EbFavoritesCreateDialogComponent,
    EbFavoritesItemHeaderComponent,
    EbFavoritesItemListComponent,
    EbFavoritesItemComponent,
    EbAddedFavoritesToCartComponent
  ],
  exports: [
    EbFavoritesComponent,
    EbFavoritesListComponent,
    EbFavoritesCreateDialogComponent,
    EbFavoritesItemHeaderComponent,
    EbFavoritesItemListComponent,
    EbFavoritesItemComponent,
    EbAddedFavoritesToCartComponent
  ],
  providers: [
    provideConfigFactory(ebFavoritesConfigFactory),
    provideConfigFactory(ebFavoritesRoutingConfigFactory),
    provideConfigFactory(ebFavoritesCmsConfigFactory),
    provideConfig(defaultFavoritesDialogModalLayoutConfig),
    EbFavoritesService,
    EbFavoritesAdapter,
    {
      provide: EB_FAVORITES_NORMALIZER,
      useExisting: OccCartNormalizer,
      multi: true
    },
    {
      provide: EB_FAVORITES_NORMALIZER,
      useExisting: EbFavoritesNormalizer,
      multi: true
    },
    {
      provide: ActiveCartFacade,
      useClass: EbActiveCartService
    },
    {
      provide: MultiCartFacade,
      useClass: EbMultiCartService
    },
    {
      provide: UserAccountFacade,
      useClass: EbUserAccountService
    }
  ]
})
export class EbFavoritesModule {}
